// Persistence for the session token + cached user. Backed by localStorage; both web and the
// Capacitor WebView share that surface. The token is also delivered as an HttpOnly cookie by
// the server, but we keep a JS-accessible copy here so cross-origin Capacitor requests can
// attach it as a Bearer header (cookies don't ride along on those calls).

import type { AuthUser } from "./types";

const TOKEN_KEY = "rithmo.session_token";
const USER_KEY = "rithmo.user";

export function loadToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function saveToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* localStorage may be disabled — fall through */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* */
  }
}

export function loadCachedUser(): AuthUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as AuthUser;
  } catch {
    return null;
  }
}

export function saveCachedUser(user: AuthUser): void {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch {
    /* */
  }
}

export function clearCachedUser(): void {
  try {
    localStorage.removeItem(USER_KEY);
  } catch {
    /* */
  }
}
